<template>
  <!-- populate switchToOtherUser() function to handle switching to another user -->
  <div
    class="tw-h-20 md:tw-h-auto"
    @click="navigateToChatroom"
  >
    <div :class="['tw-flex', 'tw-h-full', 'tw-items-center', 'tw-py-2', 'md:tw-py-3', 'tw-px-1', 'md:tw-px-3', 'tw-cursor-pointer', background, hover]">
      <img
        :src="`${$api}${chatroom.user.mainPicture.thumb}`"
        class="tw-mx-3 sm:tw-mx-1 md:tw-mx-0 tw-w-12 sm:tw-h-16 md:tw-h-20 sm:tw-w-16 md:tw-w-20 md:tw-mr-2 tw-flex-shrink-0 tw-rounded-full tw-border-2 tw-border-custom-midgray2"
      >
      <div
        class="chat-user-item-info chat-user-item-info-full md:tw-w-auto tw-mx-1 md:tw-mx-0 md:tw-block"
        :class="{ 'tw-hidden': !sidebarActive }"
      >
        <h3 class="tw-text-base md:tw-text-lg tw-font-bold">
          {{ chatroom.user.nickname }}
        </h3>
        <p class="chat-user-item-info-messageText tw-leading-tight">
          {{ chatroom.lastMessage.userId == user.id ? "you" : "them" }}: {{ chatroom.lastMessage.message | shorten(50) }}
        </p>
        <span class="tw-text-xs tw-text-custom-teal">{{ chatroom.lastMessage.timeAgo }} ago</span>
      </div>
    </div>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify';

export default {
  props: {
    active: Boolean,
    sidebarActive: Boolean,
    // toggleSidebar: Function,

    chatroom: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      show: {
        timeAgo: false,
        onlineIndicator: false,
      },
    };
  },

  computed: {
    ...sync([
      'user/user', //
      'chat/activeChatId', //
    ]),

    activeClass() {
      return this.chatroom.id === this.activeChatId ? 'active' : '';
    },

    chatAvatar() {
      return this.chatroom.type === 'group' ? 'https://via.placeholder.com/50x50' : this.chatroom.user.mainPicture.thumb;
    },

    chatLabel() {
      return this.chatroom.type === 'group' ? this.chatroom.label : this.chatroom.user.username;
    },

    background() {
      return this.active ? 'tw-bg-custom-lightgray2' : 'tw-bg-white';
    },
    hover() {
      return this.active ? '' : 'hover:tw-bg-custom-lightgray2';
    },
    cursor() {
      return this.active ? '' : 'tw-cursor-pointer';
    },
  },

  mounted() {
    // console.log('ChatListItem.mounted.chatroom', this.chatroom);
  },

  methods: {
    navigateToChatroom() {
      if (parseInt(this.$route.params.chatroomId, 10) !== this.chatroom.id) {
        this.$router.push(this.navigate(`chat/${this.chatroom.id}`));
      }
    },
  },
};
</script>

<style>
.chat-user-item-info-full {
  width: calc(100% - 6.5rem);
  transition: all 500ms linear;
}
.chat-user-item-info-half {
  @apply tw-w-48;
  transition: all 500ms linear;
}

.chat-user-item-info-messageText {
  @apply tw-text-xs tw-truncate;
}

@screen md {
  .chat-user-item-info-messageText {
    @apply tw-break-all tw-whitespace-normal tw-overflow-hidden;
    /* text-overflow: initial; */
    display: block; /* or inline-block */
    text-overflow: ellipsis;
    word-wrap: normal;
    /*overflow: hidden;*/
    max-height: 2rem;
    /*line-height: 1.5em;*/
  }
}

@screen lg {
  .chat-user-item-info-messageText {
    @apply tw-text-sm;
    max-height: 3rem;
  }
}
</style>
